import { Input as Input_ } from "@chakra-ui/react";
import { forwardRef } from "react";
export const FileInput = forwardRef(({ ...props }, ref) => {
    return <Input_ type="file" ref={ref} {...props}>{props?.children}</Input_>
});